<template>
    <div>
        <div @click="showAdd = !showAdd">
            <slot name="activator"></slot>
        </div>

        <app-input-dlg
                :show-dialog="showAdd"
                title="Add Existing User Groups"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showAdd = false"
                :body-padding="false"
        >
            <template slot="body">
                <div class="pt-1">
                    <div :class="topicClass" class="px-1">
                        <div :class="headingClass">
                            Select User Groups:
                        </div>
                    </div>
                    <div style="overflow-y: auto">
                        <multi-select-list
                                :show-action-buttons="false"
                                :show-check-boxes="true"
                                :multiple="true"
                                headline-key="description"
                                item-key="id"
                                :return-object="false"
                                v-model="selectedUserGroups"
                                :show-filter="true"
                                :items="userGroups"
                                :height="400"
                                filter-label="Filter User Groups"
                        />
                    </div>
                </div>
            </template>
            <template slot="actions">
                <div class="text-xs-right">
                    <v-btn
                            small
                            color="secondary"
                            :disabled="!Array.isArray(selectedUserGroups) || selectedUserGroups.length <= 0 || addingUserGroup"
                            :loading="addingUserGroup"
                            @click="addUserGroup"
                    >
                        {{`Add User Group${selectedUserGroups != null && selectedUserGroups.length > 1 ? 's' : ''}`}}
                    </v-btn>
                </div>
            </template>
        </app-input-dlg>
    </div>
</template>

<script>
    import {codeBaseMixin} from "../../../codeBaseMixin";
    import InputDlg from "../../../components/General/InputDlg";
    import MultiSelectList from "../../../components/Multi Select List/MultiSelectList";
    import {blankString} from "../../../codeFunctions";
    import {feed} from "../../../feedSocket";

    export default {
        components: {
            MultiSelectList,
            appInputDlg: InputDlg
        },
        mixins: [codeBaseMixin],
        props: {
            userInfo: Object,
            selectedFolderGroup: Number,
            userGroups: Array
        },
        data() {
            return {
                showAdd: false,
                addGroupDescription: null,
                selectedUserGroups: [],
                addingUserGroup: false,
            }
        },
        watch: {
            showAdd(shown) {
                if (shown) {
                    this.addGroupDescription = null;
                    this.selectedUserGroups = null;
                    this.addingUserGroup = false;
                }
            },
        },
        methods: {
            addUserGroup() {
                this.addingUserGroup = true;
                let folderGroupChanges = [];

                feed.on('folderGroupChange', (data) => {folderGroupChanges.push(data)});

                let vm = this;

                function waitForAddedFolderGroup(reFolderGroup, waitCycle = 0) {
                    return new Promise ((resolve, reject) => {
                        if (waitCycle > 20000) {
                            reject('Timeout')
                        } else {
                            if (folderGroupChanges.map(obj => {return obj.id}).includes(reFolderGroup)) {
                                vm.$nextTick(() => {
                                    resolve(reFolderGroup)
                                })
                            } else {
                                setTimeout(() => {
                                    resolve(waitForAddedFolderGroup(reFolderGroup, waitCycle + 100))
                                }, 100)
                            }
                        }
                    })
                }

                this.fetch({method: 'PATCH', url:`/folderManager/security/fgm/userGroup/${this.userInfo.entityID}/${this.selectedFolderGroup}`, body: this.selectedUserGroups})
                    .then(async () => {
                        try {
                            this.showAdd = false;
                            this.addingUserGroup = false;
                            await waitForAddedFolderGroup(this.selectedFolderGroup);

                            this.$emit('userGroupAdded', this.selectedUserGroups);
                            this.showSnack('Info', 'User Groups Added', 'Close', 'primary');
                        } catch (e) {
                            // eslint-disable-next-line
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.addingUserGroup = false;
                            console.log(e)
                        }
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingUserGroup = false;
                    })
            }
        },
        computed: {
            simpleUsers() {
                return this.users.map(user => {
                    return {
                        id: user.userID,
                        description: blankString(user.name) && blankString(user.surname) ? user.username : `${user.name} ${user.surname}`
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>
